import React, { useEffect, useState } from "react";
import { columns } from "./constants";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { getPaginationText, hasLoading } from "../../business/helpers/util";
import "./style.css";
import { ProgressSectionProposal } from "../../components";
import { getTaskBarStatistics } from "../../business/redux/reducers/statistics/actions";
import { getProposalList } from "../../business/redux/reducers/proposalReducer/actions";
import { HeaderMiddleSectionFromProposalList } from "../../components/headerSection/headerMiddleSectionFromProposalList";
import { ProgressSectionProposalByHour } from "../../components/progressSectionProposalByHour";
import { CustomFooter } from "./customFooter";

export const ProposalPage = () => {
  const dispatch = useDispatch();
  const { loading, filters, auth, proposalReducer } = useSelector((s) => s);

  const { proposalList, proposalListMeta } = proposalReducer;
  const { proposalListFilterParams } = filters;

  const [selectedLeads, setSelectedLeads] = useState({});
  const [paginationParams, setPaginationParams] = useState({
    per_page: 25,
    page: 1,
    order: {
      field: null,
      sort: "desc",
    },
  });

  useEffect(() => {
    document.title = "Proposal Activity Overview";
  }, []);

  useEffect(() => {
    dispatch(
      getProposalList({
        filterFormData: proposalListFilterParams,
        paginationParams,
      })
    );
    dispatch(getTaskBarStatistics());
  }, [auth?.__raw, JSON.stringify(paginationParams)]);

  const paginationModelChangeHandler = (e) => {
    if (hasLoading(loading)) return;
    setPaginationParams({ ...paginationParams, per_page: e.pageSize, page: 1 });
  };

  if (loading.isLoading)
    <Box
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <CircularProgress />
    </Box>;

  const paginationChangeHandler = (newPage, data) => {
    setPaginationParams({
      ...paginationParams,
      per_page: data?.per_page || 25,
      page: newPage,
    });
  };

  return (
    <Box>
      <HeaderMiddleSectionFromProposalList />
      <ProgressSectionProposal />
      <ProgressSectionProposalByHour />
      <Box sx={{ width: "100%" }}>
        <DataGrid
          className="custom_table"
          rows={proposalList}
          getRowId={(proposal) => proposal.proposal_id}
          columns={columns(dispatch)}
          autoHeight={true}
          slots={{
            footer: CustomFooter,
          }}
          slotProps={{
            footer: {
              rows: proposalList,
              columns: columns(dispatch),
              targetField: "estimated_price",
              pagination: {
                data: proposalListMeta,
                onChange: paginationChangeHandler,
              },
            },
          }}
          // sortingMode="server"
          onSortModelChange={(sortModel) =>
            setPaginationParams({
              ...paginationParams,
              order: sortModel?.at(0),
            })
          }
          onPaginationModelChange={paginationModelChangeHandler}
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
          pageSizeOptions={[25, 50, 100]}
          rowCount={proposalListMeta?.total}
          getRowClassName={(p) =>
            p.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
          loading={loading.tableLoading}
          localeText={{
            MuiTablePagination: {
              labelRowsPerPage: `Results per page /`,
              labelDisplayedRows: getPaginationText(
                proposalListMeta?.per_page || 25,
                "calls"
              ),
            },
          }}
          rowSelectionModel={
            selectedLeads[`page${proposalListMeta?.current_page}`]
          }
          onRowSelectionModelChange={(e) =>
            setSelectedLeads((prev) => ({
              ...prev,
              [`page${proposalListMeta?.current_page}`]: e,
            }))
          }
        />
      </Box>
    </Box>
  );
};
